import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TopNavComponent } from './top-nav/top-nav.component';
//import { LogoComponent } from './logo/logo.component';
import { DnMenuComponent } from './dn-menu/dn-menu.component';
import { UserStatusComponent } from './user-status/user-status.component';
import { DnSearchInputComponent } from './dn-search-input/dn-search-input.component';
import { DnUserMenuComponent } from './dn-user-menu/dn-user-menu.component';
import { BoxArrowComponent } from './theme/box-arrow/box-arrow.component';
import { DnSubmenuComponent } from './dn-menu/dn-submenu/dn-submenu.component';
import { DnMenuItemComponent } from './dn-menu/dn-menu-item/dn-menu-item.component';
import { NamecardComponent } from './namecard/namecard.component';
import { DnUserMenuItemComponent } from './dn-user-menu/dn-user-menu-item/dn-user-menu-item.component';
import { DropdrownDirective } from './dn-user-menu/dropdown/dropdown.directive';
import { DropdownMenuComponent } from './dn-user-menu/dropdown-menu/dropdown-menu.component';
import { DropdownHistoryComponent } from './dn-user-menu/dropdown-history/dropdown-history.component';
import { DropdownAutoLocateDirective } from '../_directive/dropdown-auto-locate.directive';
import { DropdownLoginRequestComponent } from './dn-user-menu/dropdown-login-request/dropdown-login-request.component';
import { FooterComponent } from './footer/footer.component';
import { DnFooterMenuComponent } from './dn-menu/dn-footer-menu/dn-footer-menu.component';
import { PartnersComponent } from './partners/partners.component';
import { DnSitesComponent } from './dn-sites/dn-sites.component';
import { DnCopyrightComponent } from './dn-copyright/dn-copyright.component';
import { DnRegionSelectorComponent } from './dn-region-selector/dn-region-selector.component';
import { ChatComponent } from './chat/chat.component';
import { SidebarTopvideosComponent } from './sidebar-topvideos/sidebar-topvideos.component';
import { RatingBarComponent } from './rating-bar/rating-bar.component';
import { BlockTitleComponent } from './block-title/block-title.component';
import { SidebarRecentUpdatesComponent } from './sidebar-recent-updates/sidebar-recent-updates.component';
import { SitebarFaqComponent } from './sitebar-faq/sitebar-faq.component';
import { VideoResolutionSymbolComponent } from './video-resolution-symbol/video-resolution-symbol.component';
import { SidebarRelatedVideosComponent } from './sidebar-related-videos/sidebar-related-videos.component';
import { FormErrorMessageComponent } from './form-error-message/form-error-message.component';
import { RechargeBoxComponent } from './recharge-box/recharge-box.component';
import { TabsModule } from '../_modules/tabs/tabs.module';
import { EmojiPickerModule } from '../_modules/emoji-picker/emoji-picker.module';
import { PipesModule } from '../_pipes/pipes.module';
import { SortButtonComponent } from './sort-button/sort-button.component';
import { PagerComponent } from './pager/pager.component';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { GenreTransformer } from '../_transformers/genre.transformer';
import { SidebarTrendingSearchesComponent } from './sidebar-trending-searches/sidebar-trending-searches.component';
import { GgBlockComponent } from './gg-block/gg-block.component';
import { CSSLoaderModule } from '../_modules/css-loaders/css-loader.module';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { ShareComponent } from './dialogs/share/share.component';
import { AlertIconComponent } from './alert-icon/alert-icon.component';
import { LoginComponent } from './dialogs/login/login.component';
import { SortableHeaderComponent } from './table/sortable-header/sortable-header.component';
import { DnCheckboxComponent } from './dn-checkbox/dn-checkbox.component';
import { LoginRequiredComponent } from './login-required/login-required.component';
import { MycardComponent } from './mycard/mycard.component';
import { SummaryComponent } from './summary/summary.component';
import { SpansExpandableComponent } from './spans-expandable/spans-expandable.component';
import { DnIconButtonComponent } from './dn-icon-button/dn-icon-button.component';
import { DropdownRechargeComponent } from './dn-user-menu/dropdown-recharge/dropdown-recharge.component';
import { CommentViewerComponent } from './comment-viewer/comment-viewer.component';
import { TopRankedVideosComponent } from './top-ranked-videos/top-ranked-videos.component';
import { SortableTableHeaderComponent } from './sortable-table-header/sortable-table-header.component';
import { SortableTableHeaderItemComponent } from './sortable-table-header/sortable-table-header-item/sortable-table-header-item.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { StickyBlockComponent } from './sticky-block/sticky-block.component';
import { AddressEditorComponent } from './address-editor/address-editor.component';
import { StickyBlockButtonComponent } from './sticky-block/sticky-block-button/sticky-block-button.component';
import { StickyBlockPopupComponent } from './sticky-block/sticky-block-popup/sticky-block-popup.component';
import { StickyBlockShadowComponent } from './sticky-block/sticky-block-shadow/sticky-block-shadow.component';
import { PurchaseRequiredComponent } from './dialogs/purchase-required/purchase-required.component';
import { CommentBoxService } from '../_modules/comment/comment-box/comment-box.service';
import { DnEmojiService } from '../_service/dn-emojis/emoji.service';
import { DnPollComponent } from '../_modules/comment/dn-poll/dn-poll.component';
import { DnPollOptionComponent } from '../_modules/comment/dn-poll-option/dn-poll-option.component';
import { PollService } from '../_service/poll/poll.service';
import { RankButtonComponent } from './dn-search-input/rank-button/rank-button.component';
import { FooterWechatComponent } from './footer-wechat/footer-wechat.component';
import { PurchaseSuccessComponent } from './dialogs/purchase-success/purchase-success.component';
import { IframeboxComponent } from './dialogs/iframebox/iframebox.component';
import { SiteConfirmationComponent } from './site-confirmation/site-confirmation.component';
import { DropdownNotificationsComponent } from './dn-user-menu/dropdown-notifications/dropdown-notifications.component';
import { DropdownNotificationsMessagesComponent } from './dn-user-menu/dropdown-notifications/dropdown-notifications-messages/dropdown-notifications-messages.component';
import { DropdownNotificationsFavoritesComponent } from './dn-user-menu/dropdown-notifications/dropdown-notifications-favorites/dropdown-notifications-favorites.component';
import { UserLevelDirective } from './user-level/user-level.directive';
import { RelatedChannelComponent } from './related-channel/related-channel.component';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { MannualComponent } from './recharge-box/mannual/mannual.component';
import { CreditcardComponent } from './recharge-box/creditcard/creditcard.component';
import { TimegatecoinComponent } from './recharge-box/timegatecoin/timegatecoin.component';
import { ScancodeComponent } from './recharge-box/scancode/scancode.component';
import { WithdrawalComponent } from './dialogs/withdrawal/withdrawal.component';
import { DailySignInButtonComponent } from './daily-sign-in-button/daily-sign-in-button.component';
import { SignInExpandedComponent } from './daily-sign-in-button/sign-in-expanded/sign-in-expanded.component';
import { DailySignInComponent } from './dialogs/daily-sign-in/daily-sign-in.component';
import { FlexboxPlaceholderDirective } from 'app/_directive/flex-placeholder.directive';
import { LazyLoadDirective } from '../_directive/lazyload.directive';
import { VideoTeaserComponent } from './video-teaser/video-teaser.component';
import { VideoTeaserSearchresultComponent } from './video-teaser/video-teaser-searchresult/video-teaser-searchresult.component';
import { VideoTeaserNewsblockComponent } from './video-teaser/video-teaser-newsblock/video-teaser-newsblock.component';
import { MembershipIconComponent } from './membership-icon/membership-icon.component';
import { VideoTeaserRecComponent } from './video-teaser/video-teaser-rec/video-teaser-rec.component';
import { OptionsComponent } from './options/options.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { DropdownSelectorComponent } from './dropdown-selector/dropdown-selector.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { VideoInputComponent } from './video-input/video-input.component';
import { DnButtonComponent } from './dn-button/dn-button.component';
import { LoadingComponent } from './loading/loading.component';
// import { RechargePageComponent } from './recharge-page/recharge-page.component';
// import { RechargeContainerComponent } from './recharge-page/recharge-container/recharge-container.component';
// import { CreditcardpayComponent } from './recharge-page/recharge-container/creditcardpay/creditcardpay.component';
// import { MannualpayComponent } from './recharge-page/recharge-container/mannualpay/mannualpay.component';
// import { ScancodepayComponent } from './recharge-page/recharge-container/scancodepay/scancodepay.component';
// import { TimegatecoinpayComponent } from './recharge-page/recharge-container/timegatecoinpay/timegatecoinpay.component';
import { SlideTogglerComponent } from './dn-slide-toggle/slide-toggler.component';
// import { TeaserDetailDialogComponent } from '../_modules/dialog/teaser-detail-dialog/teaser-detail-dialog.component';
import { VideoService } from 'app/_service/video/video.service';
//import { DnHeadlineSliderComponent } from './dn-headline-slider/dn-headline-slider.component';
import { DnRadioComponent } from './dn-radio/dn-radio.component';
import { TeaserDetailComponent } from './teaser-detail/teaser-detail.component';
import { CustomerServiceComponent } from './customer-service/customer-service.component';
import { DropdownNotificationsFollowsComponent } from './dn-user-menu/dropdown-notifications/dropdown-notifications-follows/dropdown-notifications-follows.component';
import { ReportInPageComponent } from './dialogs/report-in-page/report-in-page.component';
import { ErrorFourZeroFourComponent } from './error-four-zero-four/error-four-zero-four.component';
import { ScrolleventDirective } from '../_directive/scrollevent.directive';
import { AbsUrlPipe } from '../_pipes/abs-url.pipe';
import { NewsService } from 'app/_service/news/news.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    EmojiPickerModule,
    TabsModule,
    //SliderModule,
    PipesModule,
    CSSLoaderModule,
    // VgCoreModule,
    // VgControlsModule,
    // VgOverlayPlayModule,
    // VgBufferingModule,
    // VgStreamingModule,
    // NgxPageScrollCoreModule,
   // DnSliderModule,
    //PerfectScrollbarModule,
  ],
  declarations: [
    //LazyLoadImageModule,
    TopNavComponent,
    //LogoComponent,
    DnMenuComponent,
    UserStatusComponent,
    DnSearchInputComponent,
    DnUserMenuComponent,
    BoxArrowComponent,
    DnSubmenuComponent,
    DnMenuItemComponent,
    NamecardComponent,
    DnUserMenuItemComponent,
    DropdrownDirective,
    DropdownMenuComponent,
    // DropdownMessagesComponent,
    DropdownHistoryComponent,
    // DropdownFavoriteUpdatesComponent,
    DropdownAutoLocateDirective,
    //AutoScreenSizeDirective,
    LazyLoadDirective,
    // DropdownSubscribesComponent,
    DropdownLoginRequestComponent,
    FooterComponent,
    DnFooterMenuComponent,
    PartnersComponent,
    DnSitesComponent,
    DnCopyrightComponent,
    DnRegionSelectorComponent,
    ChatComponent,
    SidebarTopvideosComponent,
    RatingBarComponent,
    BlockTitleComponent,
    SidebarRecentUpdatesComponent,
    SitebarFaqComponent,
    VideoResolutionSymbolComponent,
    SidebarRelatedVideosComponent,
    VideoTeaserComponent,
    FormErrorMessageComponent,
    RechargeBoxComponent,
    SortButtonComponent,
    PagerComponent,
    SearchFilterComponent,
    SidebarTrendingSearchesComponent,
    GgBlockComponent,
    MessageDialogComponent,
    ShareComponent,
    AlertIconComponent,
    LoginComponent,
    SortButtonComponent,
    SortableHeaderComponent,
    DnCheckboxComponent,
    LoginRequiredComponent,
    MycardComponent,
    SummaryComponent,
    //PublisherComponent,
    SpansExpandableComponent,
    DnIconButtonComponent,
    DropdownRechargeComponent,
    //DnLiveMonitorComponent,
    //PlayButtonComponent,
    CommentViewerComponent,
    TopRankedVideosComponent,
    SortableTableHeaderComponent,
    SortableTableHeaderItemComponent,
    ConfirmDialogComponent,
    StickyBlockComponent,
    AddressEditorComponent,
    StickyBlockButtonComponent,
    StickyBlockPopupComponent,
    StickyBlockShadowComponent,
    PurchaseRequiredComponent,
    DnPollComponent,
    DnPollOptionComponent,
    RankButtonComponent,
    FooterWechatComponent,
    PurchaseSuccessComponent,
    IframeboxComponent,
    SiteConfirmationComponent,
    DropdownNotificationsComponent,
    DropdownNotificationsMessagesComponent,
    DropdownNotificationsFavoritesComponent,
    // DropdownNotificationsSubscriptionComponent,
    UserLevelDirective,
    RelatedChannelComponent,
    ContactInfoComponent,
    MannualComponent,
    CreditcardComponent,
    TimegatecoinComponent,
    ScancodeComponent,
    WithdrawalComponent,
    DailySignInButtonComponent,
    SignInExpandedComponent,
    DailySignInComponent,
    FlexboxPlaceholderDirective,
    VideoTeaserSearchresultComponent,
    VideoTeaserNewsblockComponent,
    MembershipIconComponent,
    VideoTeaserRecComponent,
    OptionsComponent,
    ProgressBarComponent,
    DropdownSelectorComponent,
    IconButtonComponent,
    VideoInputComponent,
    DnButtonComponent,
    LoadingComponent,
    // RechargePageComponent,
    // RechargeContainerComponent,
    // CreditcardpayComponent,
    // MannualpayComponent,
    // ScancodepayComponent,
    // TimegatecoinpayComponent,
    SlideTogglerComponent,
    //TeaserDetailDialogComponent,
    //DnHeadlineSliderComponent,
    DnRadioComponent,
    TeaserDetailComponent,
    CustomerServiceComponent,
    DropdownNotificationsFollowsComponent,
    ReportInPageComponent,
    ErrorFourZeroFourComponent,
    ScrolleventDirective,
  ],
  exports: [
    TopNavComponent,
   // LogoComponent,
    DnMenuComponent,
    UserStatusComponent,
    DnSearchInputComponent,
    DnUserMenuComponent,
    BoxArrowComponent,
    DnSubmenuComponent,
    DnMenuItemComponent,
    NamecardComponent,
    DnUserMenuItemComponent,
    //DropdownSubscribesComponent,
    DropdownLoginRequestComponent,
    FooterComponent,
    DnFooterMenuComponent,
    PartnersComponent,
    DnSitesComponent,
    DnCopyrightComponent,
    DnRegionSelectorComponent,
    // AutoScreenSizeDirective,
    LazyLoadDirective,
    ChatComponent,
    SidebarTopvideosComponent,
    RatingBarComponent,
    BlockTitleComponent,
    SidebarRecentUpdatesComponent,
    SitebarFaqComponent,
    VideoResolutionSymbolComponent,
    SidebarRelatedVideosComponent,
    VideoTeaserComponent,
    RechargeBoxComponent,
    SortButtonComponent,
    PagerComponent,
    SearchFilterComponent,
    SidebarTrendingSearchesComponent,
    GgBlockComponent,
    CSSLoaderModule,
    MessageDialogComponent,
    ShareComponent,
    AlertIconComponent,
    LoginComponent,
    SortButtonComponent,
    SortableHeaderComponent,
    DnCheckboxComponent,
    LoginRequiredComponent,
    MycardComponent,
    SummaryComponent,
    SpansExpandableComponent,
    DnIconButtonComponent,
    DropdownRechargeComponent,
    CommentViewerComponent,
    TopRankedVideosComponent,
    SortableTableHeaderComponent,
    SortableTableHeaderItemComponent,
    ConfirmDialogComponent,
    StickyBlockComponent,
    AddressEditorComponent,
    StickyBlockButtonComponent,
    PurchaseRequiredComponent,
    DnPollComponent,
    DnPollOptionComponent,
    RankButtonComponent,
    FooterWechatComponent,
    PurchaseSuccessComponent,
    IframeboxComponent,
    SiteConfirmationComponent,
    UserLevelDirective,
    RelatedChannelComponent,
    ContactInfoComponent,
    WithdrawalComponent,
    DailySignInComponent,
    FlexboxPlaceholderDirective,
    VideoTeaserSearchresultComponent,
    VideoTeaserNewsblockComponent,
    MembershipIconComponent,
    VideoTeaserRecComponent,
    OptionsComponent,
    ProgressBarComponent,
    DropdownSelectorComponent,
    IconButtonComponent,
    VideoInputComponent,
    DnButtonComponent,
    LoadingComponent,
    // RechargePageComponent,
    SlideTogglerComponent,
    //TeaserDetailDialogComponent,
   // DnHeadlineSliderComponent,
    DnRadioComponent,
    TeaserDetailComponent,
    CustomerServiceComponent,
    ReportInPageComponent,
    ScrolleventDirective,
    AbsUrlPipe
  ],
  // entryComponents: [
  //   DropdownMenuComponent,
  //   DropdownHistoryComponent,
  //   DropdownRechargeComponent,
  //   DropdownNotificationsComponent,

  // ],
  providers: [
    CommentBoxService,
    DnEmojiService,
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    GenreTransformer,
    PollService,
    VideoService,
    NewsService,
  ],
})
export class SharedModule { }
